export default __webpack_public_path__ + "static/media/Local Road - Road.230c5187.svg";